import { IconButton, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import Close from '@mui/icons-material/Close';
import { AvatarImage } from '~/shared/components/AvatarImage';
import type { User } from '~/shared/types/connect';

interface Props {
  expert: User;
  onClear: () => void;
}

export function ExpertFilterChip({ expert, onClear }: Props) {
  const name = expert.name ?? '';
  const expertLabel = name || 'selected expert';
  return (
    <Chip>
      <ChipAvatar
        avatarUrl={expert.avatarUrl}
        initialsLabel={name}
        alt={name}
      />
      <ChipName variant="caption">{name}</ChipName>
      <ClearButton
        size="small"
        onClick={onClear}
        aria-label={`Clear filter for ${expertLabel}`}
      >
        <Close fontSize="inherit" />
      </ClearButton>
    </Chip>
  );
}

const Chip = styled(Stack)(({ theme }) => ({
  display: 'inline-flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(0.75),
  borderRadius: 9999,
  padding: theme.spacing(0.5, 0.75, 0.5, 1.25),
  backgroundColor: theme.palette.action.hover,
  color: theme.palette.text.primary,
  alignSelf: 'center',
}));

const ChipAvatar = styled(AvatarImage)(({ theme }) => ({
  width: 28,
  height: 28,
  fontSize: theme.typography.caption.fontSize,
}));

const ChipName = styled(Typography)({
  fontSize: '0.8125rem',
  fontWeight: 600,
  maxWidth: 200,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

const ClearButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0.25),
  fontSize: theme.typography.caption.fontSize,
  color: theme.palette.text.secondary,
  '&:hover': {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.action.selected,
  },
}));
